import {LINK_TYPES, ROUTE_NAMES, ROUTE_TYPES} from "../../../core/consts";
import {BaseModel} from "../base-model";
import {BaseLinkParams} from "./base-link-params";
import {BaseLinkModelSettings} from "./base-link-model-settings";
import {BaseHashParamsModel} from "../../../core/components/router/models/base-hash-params-model";

export class BaseLinkModel extends BaseModel {
  type: LINK_TYPES;
  name: ROUTE_NAMES;
  params: BaseLinkParams;
  exact: Boolean;
  cultureName: Boolean;
  settings: BaseLinkModelSettings;
  enabled: Boolean;
  onClick: Function;
  replace: Boolean;
  screen: String;
  hashParams: BaseHashParamsModel;
  _isLinkTag: Boolean;
  routeType: ROUTE_TYPES;
  parent: String;

  constructor(name: ROUTE_NAMES, params: BaseLinkParams, exact: Boolean = false, cultureName: String = null, screen: String = null, hashParams: BaseHashParamsModel = null, isLinkTag: Boolean = true, routeType: ROUTE_TYPES = ROUTE_TYPES.default, parent: String) {
    super();

    this.type = LINK_TYPES.internal;
    this.name = name;
    this.exact = exact;
    this.params = params;
    this.cultureName = cultureName;
    this.enabled = true;
    this.replace = false;
    this.screen = screen;
    this.hashParams = hashParams;
    this.settings = new BaseLinkModelSettings();
    this._isLinkTag = isLinkTag;
    this.routeType = routeType;
    this.parent = parent || null;
  }

  set isLinkTag(bool) {
    this._isLinkTag = bool;
  }

  get isLinkTag() {
    return this._isLinkTag;
  }

  equals(model): * {
    return this.name === model.name &&
      this.exact === model.exact &&
      this.cultureName === model.cultureName &&
      this.enabled === model.enabled &&
      this.routeType === model.routeType &&
      JSON.stringify(this.params) === JSON.stringify(model.params) &&
      this.hashParams?.toString() === model.hashParams?.toString();
  }

  clone(settings: BaseLinkModelSettings) {
    const clonedLinkModel = {...this};

    if (settings) {
      clonedLinkModel.settings = settings;
    }

    return clonedLinkModel;
  }

  get hash(): String {
    return this.hashParams?.toString();
  }

  get isLinkValid() {
    return true;
  }
}
